import React, { useEffect, useState } from 'react'
import { Link, useParams } from "react-router-dom";
import GrievanceTable from '../GrievancesTable/GrievanceTable';
import DataTable from '../../common/DataTable/DataTable';
import styles from '../../common/DataTable/DataTable.module.css'
import Button from '../../common/Button/Button';
import { REACT_APP_API_BASE_URL } from '../../../apiurl';



const GrievanceResponse = () => {
    const { id } = useParams();

    const columns = [
        {
            key: "user_id",
            label: "USER ID",
        },
        // {
        //     key: "response_date",
        //     label: "RESPONSE DATE",

        // },
        {
            key: "response_date",
            label: "RESPONSE DATE",
            render: (value) => {
                if (!value) return "-";
                return new Date(value).toISOString().split("T")[0];
            },

        },

        {
            key: "response_time",
            label: "RESPONSE TIME",
        },
        {
            key: "response_text",
            label: "RESPONSE TEXT",
        },
        {
            key: "responded_by",
            label: "RESPONDED BY",
        },
        {
            key: "closed_date",
            label: "CLOSED DATE",
            render: (value) => {
                if (!value) return "-";
                return new Date(value).toISOString().split("T")[0];
            },

        },
        {
            key: "complaint_status",
            label: "COMPLAINT STATUS",
        },
        {
            key: "closed_time",
            label: "CLOSED TIME",
        },
        {
            key: "clousure_text",
            label: "CLOSURE TEXT",
        },
        {
            key: "closed_by",
            label: "CLOSED BY",
        },
        {
            key: "communication_track_id",
            label: "COMMUNICATION TRACK ID",
        },
        {
            key: "attachment",
            label: "ATTACHMENT",
            render: (value) => (
                <img
                    src={value ? `${REACT_APP_API_BASE_URL}uploads/attachments/${value}` : ""}
                    alt="Module"
                    style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "6px",
                        objectFit: "cover",
                        cursor: "pointer",
                        border: "1px solid #ddd",
                    }}
                    onClick={() => setPreviewImage(`${REACT_APP_API_BASE_URL}uploads/moduleimages/${value}`)}
                />
            ),
        },
    ];

    const [grievanceData, setGrievanceData] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);

    useEffect(() => {
        const fetchGrievanceData = async () => {
            try {
                const response = await fetch(`${REACT_APP_API_BASE_URL}api/grievance/grievancemeta/${id}`);
                const data = await response.json();
                setGrievanceData(data.data || null);
            } catch (error) {
                console.error('Error fetching grievance data:', error);
            }
        };

        fetchGrievanceData();
    }, [id]);

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px', marginTop: '16px' }}>
                <Link to="/grievances" style={{ textDecoration: "none" }}>
                    <Button style={{ marginBottom: '16px', color: 'white' }}>
                        Back
                    </Button>
                </Link>
                <Link to={`/grievances/response/add/${id}`} style={{ textDecoration: "none" }}>
                    <Button style={{ marginBottom: '16px', color: 'white' }}>
                        + Add
                    </Button>
                </Link>

            </div>

            <DataTable
                title={`Grievance meta Details (Complaint Id: ${id})`}
                columns={columns}
                data={grievanceData ? grievanceData : []}
                noScroll={true}
            />
            {previewImage && (
                <div
                    onClick={() => setPreviewImage(null)}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "rgba(0,0,0,0.7)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 2000,
                        cursor: "pointer",
                    }}
                >
                    <img
                        src={previewImage}
                        alt="Preview"
                        style={{
                            maxWidth: "90%",
                            maxHeight: "90%",
                            borderRadius: "8px",
                            boxShadow: "0 0 20px rgba(255,255,255,0.6)",
                        }}
                    />
                </div>
            )}
        </div>
    )
}

export default GrievanceResponse